module.exports = __webpack_public_path__ + "img/hr-green-pita-00.bae24139.png";